import axios from '@axios'
import { sortProductTags } from '@/libs/productTags'

const state = () => ({
  productTags: {
    meta: {
      pagination: {
        page: 1,
        per_page: 10,
        total_objects: 0,
      },
    },
    data: [],
  },
})

const getters = {
  productTags(state) {
    return sortProductTags(state.productTags.data)
  },
}

const mutations = {
  SET_PRODUCT_TAGS(state, payload) {
    state.productTags = payload
  },
}

const actions = {
  fetchProductTags(
    context,
    params = {
      by_active_status: true,
    },
  ) {
    return new Promise((resolve, reject) => {
      axios
        .get('/v1/product_tags', {
          params: {
            ...params,
            meta: {
              pagination: {
                all: true,
              },
            },
          },
        })
        .then(response => {
          context.commit('SET_PRODUCT_TAGS', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  addProductTag(context, productTag) {
    return new Promise((resolve, reject) => {
      axios
        .post('/v1/product_tags', {
          product_tag: productTag,
        })
        .then(response => {
          context.dispatch('fetchProductTags')
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  fetchProductTag(context, { productTagId }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/v1/product_tags/${productTagId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  editProductTag(context, productTag) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/v1/product_tags/${productTag.id}`, {
          product_tag: productTag,
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  deactivateProductTag(context, productTag) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/v1/product_tags/${productTag.id}`, {
          product_tag: { ...productTag, active_status: !productTag.active_status },
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
